module.exports = __webpack_public_path__ + "assets/img/6cf63550af06dde3e20cae4f060f5def.png";